import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { FN_FIELD_IMAGE_ASSET__init_image } from './FN_FIELD_IMAGE_ASSET__init_image';

// returns true if any image was initialized
export function FN_IMAGE_ASSET__add_to_generation_single(generation: DTO__generation, images_map_by_hash: Map<string, DTO__image_asset>) {
  let fields = generation.tool.graph.fields__get_by_type(FIELD__image_asset);
  fields = fields.filter(field => !field.is_stub()); //skip stubs

  let out = FN_FIELD_IMAGE_ASSET__init_image(images_map_by_hash, fields);

  return out;
}
